import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Section } from "@/components/partner/Section";

// The 50 Founding Partners, in the order they joined. Partners only.
export default function FoundingWall() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/partner/founding-wall").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const open = d.total - d.partners.length;
  return (
    <Section id="founders" eyebrow="Founding Partners" title="The first fifty" sub={open > 0 ? `${d.partners.length} of ${d.total} places taken. ${open} still open.` : "All fifty places are taken. These are the people who started it."}>
      <div className="rounded-3xl border border-amber-300/20 bg-gradient-to-br from-amber-300/[0.05] to-transparent p-6 sm:p-8" data-testid="founding-wall">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-3">
          {d.partners.map((p, i) => (
            <div key={i} className={`flex items-center gap-2 text-sm ${p.me ? "text-amber-200" : "text-foreground/85"}`} data-testid={`founding-wall-${i}`}>
              <span className="w-6 text-right text-[10px] text-muted-foreground tabular-nums">{p.no || i + 1}</span>
              <Star className="w-3 h-3 text-amber-300/70" fill="currentColor" />
              <span className="font-serif text-base truncate">{p.name}{p.me ? " (you)" : ""}</span>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
